import { esActiva } from "./etapas";
import { diasEntre } from "./fechas";
import type { Negocio, UmbralesSemaforo } from "./tipos";

export type ColorSemaforo = "verde" | "azul" | "amarillo" | "naranja" | "rojo";

export const COLORES_SEMAFORO: ColorSemaforo[] = [
  "verde",
  "azul",
  "amarillo",
  "naranja",
  "rojo",
];

/**
 * Días naturales desde el último contacto; si nunca se contactó, desde el alta. La consultoría
 * hecha también es contacto (Robert, 30/10/2026: tras «Se hizo» seguía saliendo «7 días sin
 * contacto»). Nunca negativo (un contacto registrado "en el futuro" cuenta como hoy).
 */
export const diasSinContacto = (
  negocio: Pick<
    Negocio,
    "ultimo_contacto" | "created_at" | "consultoria_realizada_at"
  >,
  hoy: Date = new Date(),
): number => {
  const fechas = [negocio.ultimo_contacto, negocio.consultoria_realizada_at]
    .filter((f): f is string => !!f)
    .map((f) => new Date(f).getTime());
  const referencia = fechas.length
    ? new Date(Math.max(...fechas))
    : new Date(negocio.created_at);
  return Math.max(0, diasEntre(referencia, hoy));
};

/** Color según días y umbrales (SPEC.md §4): ≤verde, ≤azul, ≤amarillo, ≤naranja, resto rojo. */
export const colorPorDias = (
  dias: number,
  umbrales: UmbralesSemaforo,
): ColorSemaforo => {
  if (dias <= umbrales.verde) return "verde";
  if (dias <= umbrales.azul) return "azul";
  if (dias <= umbrales.amarillo) return "amarillo";
  if (dias <= umbrales.naranja) return "naranja";
  return "rojo";
};

/** Semáforo de una tarjeta, o null si su etapa no lleva (aparcadas, Cobrado y Clientes). */
export const semaforo = (
  negocio: Pick<
    Negocio,
    "etapa" | "ultimo_contacto" | "created_at" | "consultoria_realizada_at"
  >,
  umbrales: UmbralesSemaforo,
  hoy: Date = new Date(),
): ColorSemaforo | null =>
  esActiva(negocio.etapa)
    ? colorPorDias(diasSinContacto(negocio, hoy), umbrales)
    : null;
